import { Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CombosConfiguration, FunctionsService, HttpService, LocalStorageService, MenuBreadCrumb, MessageService, params, SessionService, TableColumns, TableConfiguration } from 'brainloper-ui';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { NotificationsService } from 'app/services/notifications.service';
import { ResourcesService } from 'app/services/resources.service';
import { DeleteGenericService } from 'app/services/delete-generic.service';
import { Resources } from 'app/models2/maintenance/resources';
import { Item } from 'app/models2/inventory/item';
import { EmergingActivity } from 'app/models2/maintenance/emerging-activities';
import { UpdateData } from 'app/models2/commos/update-data';
import { BaseResponse } from 'app/models2/commos/base-response';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { DataResouce } from 'app/models2/commos/base-response-data';
import { TypeMaintenance } from '@edgarzon93/brainloper-shared';
import { WorkOrderService } from 'app/services/work-order.service';

@Component({
  selector: 'app-maintenance-request-notification',
  templateUrl: './maintenance-request-notification.component.html',
  styleUrls: ['./maintenance-request-notification.component.scss']
})
export class MaintenanceRequestNotificationComponent implements OnInit {

public bodyActividad: EmergingActivity = {}
public view: boolean = false
public action: string = ''
private order

private urlActividadEmerg: string = `${EndpointDictionary.ActivityeEmerg.CRUD_ACTIVITY_EMERG_DATA}`
public urlGetTablaResourcesRequest: string = `${EndpointDictionary.ResourcesRequest.RESOURCES_REQUEST_TABLE}`
public urlGetCrudResourcesRequest: string = `${EndpointDictionary.ResourcesRequest.CRUD_RESOURCES_REQUEST_DATA}`

private resourceByRequest: Item[] = []

private odometro:number
public formEdit: UntypedFormGroup

public movil: boolean

private selected = new UntypedFormControl(0);
public typeOfMaintenance:TypeMaintenance[] = []

public combosTypeOfMaintenance: CombosConfiguration = {
  visibleField: 'name',
  selectionField: 'id',
  label: 'Tipo Mantenimiento',
  fileTooltip:"description"
};
public reloadComboTypeOfMaintenance = new EventEmitter<any>();

public menuBreadCrumb:Array<MenuBreadCrumb> = [
  {
    name:"Inicio",
    router:'/inicio',
  },
  {
    name:"Notificaciones",
  },
  {
  name:"Solicitud",
  current:true
  }
]

private id_notificacion: number = this.session.getData('id_notificacion')
public rol: string = this.storage.get<string>('rol')


 //Tabla Recursos
 public labels = []
 public reloadResoucesRequest = new EventEmitter<any>()
 public paramsResourcesRequest: params [] = [{ id: 'requestId', value: '0' }]
 public paramsResourcesRequestEdit: params [] = [{ id: 'requestId', value: '0' }]
 public configurationResouces: TableConfiguration = {
   edit: false,
   add: false,
   delete: false,
   selectable: false,
   addPer: false,
   editPer: false,
   primaryKey: 'id',
   print: false,
 };

 public configurationResoucesEdit: TableConfiguration = {
  edit: true,
  add: true,
  delete: true,
  selectable: true,
  addPer: false,
  editPer: false,
  primaryKey: 'id',
  print: false,
};

 public columnsResouces: TableColumns<Item>[] = [
   {
     ID: 'itemName',
     label: 'Nombre',
     type: 'combo',
     disregardForEdit: true,
     style: {
       textAlign: 'center',
     },
     required:true,
     paramsCombo: {
       selectionField: 'id',
       visibleField: 'itemName',
       url: `${EndpointDictionary.Item.ITEM_COMBO}`,
      }
   },
   {
     ID: 'unitMeasurement',
     label: 'Unidad',
     type: 'text',
     disregardForAdd: true,
     disregardForEdit: true,
     style: {
       textAlign: 'center',
       movil: 'no-movil'
     },

   },
   {
     ID: 'amount',
     label: 'Cantidad',
     type: 'number',
     style: {
       textAlign: 'center'
     },
     required:true,
   },

 ];

 public inventoryModule: boolean = this.storage.get<boolean>('inventory_module')
 public resources: Array<Resources> = [{itemName:''}]
 public viewCarousel: boolean = true
 public totalCostItems: number

  constructor(
    private activeRoute: ActivatedRoute,
    private http: HttpService,
    private message: MessageService,
    private session: SessionService,
    private functioEter: FunctionsService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private functions: FunctionsService,
    public notificationService: NotificationsService,
    private storage : LocalStorageService,
    private resourcesService: ResourcesService,
    public deleteItem: DeleteGenericService,
    private workOrderService: WorkOrderService
  ) {
    this.formEdit = this.formBuilder.group({
      description: '',
      executionDate:'',
      maintenanceType:'',
      resources:''
    })
   }

  async ngOnInit() {
    this.typeOfMaintenance = await this.workOrderService.getTypeOfMaintenance()
    this.validateInventoryModule()
    this.movil = screen.width > 600 ? false : true
    window.addEventListener('resize', () => {
      this.movil = screen.width > 600 ? false : true
    })
    this.init()
  }

  validateInventoryModule(){
    if (!this.inventoryModule || this.resources.length <= 0) {
      this.viewCarousel = false
    }
  }

  async init() {
    this.message.openLoading('Cargando', 'Cargando información')
    this.id_notificacion = this.session.getData('id_notificacion')
    this.activeRoute.queryParamMap
      .subscribe(async(params) => {
        this.order = { ...params };
        this.paramsResourcesRequest = [{ id: 'requestId', value: this.order.params.id_actividad_emergente }]
        let res: Array<EmergingActivity> = await this.http.getDataBody(`${this.urlActividadEmerg}/${this.order.params.id_actividad_emergente}`)
        if (res) {
          this.bodyActividad = res[0]
          this.bodyActividad.date = this.functioEter.dateIso(res[0].date)
          this.odometro = this.bodyActividad.currentOdometer
          this.view = true
          this.message.closeLoading()
        }
      })
  }

  async response($event: string){
    try {
      if ($event == 'autorizar') {
        this.message.openLoading('Cargando', 'Autorizando notificación')
        this.session.setData('data', { action: 'solicitud', body:this.bodyActividad, id_notificacion:this.id_notificacion, odometro:this.odometro})
        this.message.closeLoading()
          this.message.SuccessToast('Solicitud Autorizada')
          this.router.navigate(["/mantenimiento/orden_trabajo"])
          setTimeout(() => {
            this.router.navigate(["/mantenimiento/orden_trabajo/detalle"])
          }, 500);
      }else{
        this.message.Warning('Desea rechazar la solicitud', '', true).then(
          (res: boolean) => {
            if(res==true){
              this.rechazarSolicitud()
            }
          }
        )
      }

    } catch (error) {
      this.message.Error('Error', error['message'])
    }
  }

  async rechazarSolicitud(){
    this.message.openLoading('Cargando', 'Rechazando notificación')
    let bodyNotification = {
      description:`Solicitud rechazada ${this.bodyActividad.description}`,
      notificado:this.bodyActividad.requests
  }
    let resDeleteActividad: BaseResponse<GenericResponse> = await this.http.deleteDataPromise(`${this.urlActividadEmerg}/${this.bodyActividad.id}`)
    if(resDeleteActividad['code']===0){
      this.notificationService.deleteNotificationByUrl(`notificaciones/solicitudes?id_actividad_emergente=${this.bodyActividad.id}`)
          this.message.closeLoading()
          this.message.SuccessToast('Solicitud rechazada')
          this.notificationService.sendNotificationInformative(bodyNotification.description, bodyNotification.notificado)
          setTimeout(() => {
            this.router.navigate(["/inicio"])
          }, 500);
  }else{
      this.message.Error('Error', resDeleteActividad['message'])
    }
  }

  dataResources($event: DataResouce<Resources[]>){
    this.resources = $event.data
    this.totalCostItems = $event.totalCostItems
    this.validateInventoryModule()
    this.labels = [
      {
        label: 'Total:',
        value: `$  ${Intl.NumberFormat('es-CO').format(this.totalCostItems)}`,
        edit:false
      }
    ]
  }


  edit($event: string){
    this.paramsResourcesRequestEdit = [{ id: 'requestId', value: this.order.params.id_actividad_emergente }]
    this.formEdit.controls.description.setValue(this.bodyActividad.description)
    this.combosTypeOfMaintenance.selected = this.bodyActividad.maintenanceType
    this.reloadComboTypeOfMaintenance.emit("selected")
    this.formEdit.controls.maintenanceType.setValue(this.bodyActividad.maintenanceType)
    this.formEdit.controls.executionDate.setValue(`${this.bodyActividad.date}T08:00:00.000Z`)
    this.formEdit.controls.resources.setValue(this.bodyActividad.resources)
    this.view = false
    this.action = $event
  }

  getResourceByRequestTable($event: DataResouce<Resources[]>){
    if($event && $event.data){
      this.resourceByRequest = $event.data
    }
  }

  async deleteResources($event:Array<Resources>) {
    await this.deleteItem.deleteD($event, this.urlGetCrudResourcesRequest, "id", "Recurso", "Recursos")
      this.reloadResoucesRequest.emit()
  }

   async addResources($event:Resources){
    if(this.resourceByRequest.find(x => x.itemInventoryId.toString() == $event.itemName)){
      this.message.Warning("Advertencia", "Item ya seleccionado")
      return
    }
    $event.itemId = parseInt($event.itemName)
    await this.resourcesService.addResourcesFromTable($event, this.order.params.id_actividad_emergente, false)
    this.reloadResoucesRequest.emit()
   }

   async editResources($event: UpdateData<Resources>){
    await this.resourcesService.editResourcesFromTable($event, this.order.params.id_actividad_emergente, false)
    this.reloadResoucesRequest.emit()
   }

   changesTypeOfMaintenance($event: string){
    this.formEdit.controls.maintenanceType.setValue($event)
  }

  async finalizar(data: EmergingActivity){
    this.message.openLoading('Cargando', 'Actualizando solicitud')
   // console.log(data)
  let form = {
  id:this.bodyActividad.id,
  description:data.description,
  cost:this.bodyActividad.cost,
  requests:this.bodyActividad.requests,
  equipmentId:this.bodyActividad.equipmentId,
  date:this.functions.dateForm(data.executionDate),
  maintenanceType:data.maintenanceType,
  resources: data.resources
}

  let res: GenericResponse = await this.http.putDataBody(`${this.urlActividadEmerg}`, form)
  if(res){
    this.message.SuccessToast('Solicitud actualizada correctamente')
    setTimeout(() => {
      this.router.navigate(['inicio'])
      this.message.closeLoading()
    }, 500);

  }

//console.log(form)
  }

  back() {
    this.view = true
    this.action = 'soliciud'
  }

  errorMessage(){
    this.message.Error('Error', 'Complete los campos')
  }

}

